import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { Button, Grid, Tooltip } from "@mui/material";
import { Formik } from "formik";
import FormikTextField from "../../commons/formik/FormikTextField";
import CircularLoading from "../../commons/loading/CircularLoading";
import { StyledABMNomina } from "../../styled/Personal"; // Importa estilos de ABMNomina
import { siniestroFormValidation } from "../validation/formValidation";

const SiniestroForm = ({ model, handleSubmit, isLoading }) => {

  return (
    <>
      {!isLoading ? (
        <Formik
          initialValues={model}
          onSubmit={handleSubmit}
          validationSchema={siniestroFormValidation}
        >
          <StyledABMNomina.FormContainer>
            <StyledABMNomina.GridContainer container spacing={10}>
              <StyledABMNomina.InputContainer item xs={5}>
                <FormikTextField
                  fullWidth
                  id="nroSiniestro"
                  name="nroSiniestro"
                  type="text"
                  label="Nro. Siniestro"
                />
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={5}>
                <FormikTextField
                  fullWidth
                  id="nroDocumento"
                  name="nroDocumento"
                  type="text"
                  label="Nro. Documento"
                />
              </StyledABMNomina.InputContainer>
              <Grid item xs={2} style={{ marginTop: 20 }}>
                <Tooltip title="Buscar Siniestros" arrow>
                  <Button type="submit">
                    <PersonSearchIcon fontSize="large" />
                  </Button>
                </Tooltip>
              </Grid>
            </StyledABMNomina.GridContainer>
          </StyledABMNomina.FormContainer>
        </Formik>
      ) : (
        <CircularLoading />
      )}
    </>
  );
};

export default SiniestroForm;
